export * from './simple-layout.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/containers/simple-layout/index.ts